import dayjs from '../../dayjs';

/**
 * @description: 获取用户当前时区信息（兼容国产化环境）
 * @param {DateType} date
 * @return {*}
 */
export function getUserOffsetName() {
  let o = dayjs.tz.guess()
  if (o === 'Etc/Unknown') {
    const offset = new Date().getTimezoneOffset()
    const offset_hour = Math.round(offset / 60)
    if (offset_hour === 0) {
      o = 'Europe/London'
    } else if (offset_hour > 0) {
      o = `Etc/GMT+${offset_hour}`
    } else {
      switch (offset_hour) {
        case -1:
          o = 'Europe/Berlin'
          break;
        case -2:
          o = 'Europe/Bucharest'
          break;
        case -3:
          o = 'Europe/Moscow'
          break;
        case -4:
          o = 'Asia/Tbilisi'
          break;
        case -5:
          o = 'Asia/Karachi'
          break;
        case -6:
          o = 'Asia/Dhaka'
          break;
        case -7:
          o = 'Asia/Bangkok'
          break;
        case -8:
          o = 'Asia/Shanghai'
          break;
        case -9:
          o = 'Asia/Tokyo'
          break;
        case -10:
          o = 'Australia/Brisbane'
          break;
        case -11:
          o = 'Australia/Sydney'
          break;
        case -12:
          o = 'Asia/Kamchatka'
          break;
        default:
          o = 'Asia/Shanghai'
          break;
      }
    }
  }
  return o
}

/**
 * @description: 判断传入的string类型日期是否含有时区信息
 * @param {any} date
 * @return {*}
 */
export function isStrDateContainUTC(date: any) {
  const date1 = dayjs(date)
  if (date1.isValid()) {
    //注意此处需要兼容date为invalid的情况，dayjs.tz目前版本还未兼容invalid Date的输出，会导致页面直接白屏
    const date2 = dayjs.tz(date)
    if (date2.isValid()) {
      return !date1.isSame(date2)
    }
  }
  return true
}
